import { message } from "antd";
import useRequest from "./useRequest";
import { useState } from "react";
import dayjs from "dayjs";

const useGroups = () => {
  const [groups, setGroups] = useState([]);
  const [group, setGroup] = useState(null);
  const [loading, setLoading] = useState({
    get: false,
    post: false,
    put: false,
    delete: false,
  });

  const { request } = useRequest();

  async function getGroup(groupId) {
    setLoading((prev) => ({ ...prev, get: true }));
    const data = await request(
      "GET",
      `groups/${groupId}/`,
      (data) => {
        setLoading((prev) => ({ ...prev, get: false }));
        setGroup(data);
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, get: false }));
        return error;
      },
      {}
    );
    return data;
  }

  async function getGroups(params = {}) {
    return await request(
      "GET",
      "groups/",
      (data) => {
        setGroups(data);
        return data;
      },
      (error) => {
        return error;
      },
      {},
      params
    );
  }

  async function createGroup(body) {
    setLoading((prev) => ({ ...prev, post: true }));
    const data = await request(
      "POST",
      "groups/",
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.success("Grupo creado exitosamente");
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.error("Error al crear el grupo");
        return error;
      },
      body
    );
    return data;
  }

  async function updateGroup(body) {
    setLoading((prev) => ({ ...prev, edit: true }));
    const data = await request(
      "PATCH",
      `groups/${body.id}/`,
      (data) => {
        setLoading((prev) => ({ ...prev, edit: false }));
        message.success("Grupo actualizado exitosamente");
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, edit: false }));
        message.error("Error al actualizar el grupo");
        return error;
      },
      body
    );
    return data;
  }
  async function deleteGroup(groupId) {
    setLoading((prev) => ({ ...prev, delete: true }));
    const data = await request(
      "DELETE",
      `groups/${groupId}/`,
      (data) => {
        setLoading((prev) => ({ ...prev, delete: false }));
        message.success("Grupo eliminado correctamente");
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, delete: false }));
        return error;
      },
      {},
      {}
    );
    return data;
  }

  async function unsetExcursionFromGroup(groupId, excursionId) {
    setLoading((prev) => ({ ...prev, delete: true }));
    const data = await request(
      "DELETE",
      `groups/group-schedule/${groupId}/${excursionId}/`,
      (data) => {
        setLoading((prev) => ({ ...prev, delete: false }));
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, delete: false }));
        return error;
      },
      {}
    );
    return data;
  }

  async function setExcursionToGroup(groupId, excursionId) {
    setLoading((prev) => ({ ...prev, post: true }));
    const data = await request(
      "POST",
      `groups/group-schedule/`,
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.success("Excursion añadida con éxito");
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, post: false }));
        return error;
      },
      {
        group: groupId,
        scheduledExcursions: excursionId,
      },
      {}
    );
    return data;
  }

  async function getCoordinatorCommission(userId) {
    const data = await request(
      "GET",
      `groups/coordinator-commission/${userId}/`,
      (data) => {
        return data;
      },
      (error) => {
        return error;
      },
      {}
    );
    return data;
  }

  async function getCoordinatorCommission(userId) {
    const data = await request(
      "GET",
      `groups/coordinator-commission/${userId}/`,
      (data) => {
        return data;
      },
      (error) => {
        return error;
      },
      {}
    );
    return data;
  }

  return {
    getGroup,
    getGroups,
    group,
    groups,
    setGroup,
    setGroups,
    createGroup,
    loading,
    deleteGroup,
    setExcursionToGroup,
    unsetExcursionFromGroup,
    updateGroup,
  };
};

export default useGroups;
